<template>
  <v-container fluid class="pa-0">
  <!-- //  <material-card icon="mdi-clipboard-text" inline title="Service concession Approval list"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="6" lg="4" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Service concession Approval list
                </div>
              </div>
            </div>
          </v-col>
            <v-col cols="12" md="6" lg="4">
              <v-autocomplete hide-details="" label="Status" class="my-0 py-1" :items="items" item-text="text" item-value="value" placeholder="--All--" name="classSelect" v-model="selectedStatus"> </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" lg="4">
                      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            dense
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
        </v-card-text>
            </v-col>
        </v-row>
        <v-divider class=" my-0 " />
        <v-data-table
          :search.sync="search"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          hide-default-footer
          :items-per-page="10"
          :headers="headers"
          :items="students"
        >
          <template v-slot:item.name="{ item }">
            <span class="text-capitalize">
              {{ item.assignFeeComponent.enquiry.studentFirstName }}
            </span>
          </template>
          <template v-slot:item.isActive="{ item }">
            {{ item.isActive ? 'Active' : 'In Active' }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ new Date(item.createdAt).toLocaleString() }}
          </template>
          <template v-slot:item.status="{ item }">
            <div :class="getColor(item.status)">
              {{ item.status }}
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <router-link :to="{ name: 'serviceConcessionFeePlan', params: { enquiryID: item.id } }">
              <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
                <v-col v-if="students.length != 0">
          <v-row>
            <v-col cols="4" sm="3">
              <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination v-model="page" :length="totalPages" :total-visible="10" @input="handlePageChange"></v-pagination>
            </v-col>
          </v-row>
        </v-col>
    </v-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
// import MaterialCard from '@/components/template/MaterialCard'
// import VCardComponent from '@/components/template/VCardComponent'
import { mapGetters } from 'vuex'
// import moment from 'moment'

export default {
  name: 'studentDetails',
  // components: { MaterialCard, VCardComponent },
  data () {
    return {
      students: [],
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100],
      search: '',
      franchiseeID: '',
      franchiseeArr: [],
      selectedClassID: '',
      isLoading: false,
      classWiseSections: [],
      totalStudents: 0,
      academicYearID: '',
      selectedStatus: '',
      academicYears: [],
      inProgress: false,
      items: [
        { text: 'Approved', value: 'APPROVED' },
        { text: 'Pending', value: 'PENDING' },
        { text: 'Rejected', value: 'REJECTED' },
        { text: 'Applied', value: 'APPLIED' }
      ],
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Enquiry Code', value: 'assignFeeComponent.enquiry.enquiryCode', sortable: true },
        { text: 'Fee Plan', value: 'assignFeeComponent.feeComponent.name', sortable: true },
        { text: 'Franchisee', value: 'assignFeeComponent.franchisee.companyName', sortable: true },
        { text: 'Acadamic year', value: 'assignFeeComponent.franchiseeAcademicYear.academicYear', sortable: true },
        { text: 'Created AT', value: 'createdAt', sortable: true },
        { text: 'status', value: 'status', sortable: true },
        { text: 'isActive', value: 'isActive', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  created: async function () {
    await this.getYearList()
    await this.onFranchiseeChange()
    // await this.getStudents()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    selectedStatus: async function () {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    getColor (status) {
      if (status === 'APPROVED') return 'v-green font-weight-bold'
      if (status === 'REJECTED') return 'v-error font-weight-bold'
      else if (status === 'APPLIED') return 'v-darkblue font-weight-bold'
      else if (status === 'PENDING') return 'v-warning font-weight-bold'
      else return 'v-secondary'
    },
    getYearList: async function () {
      try {
        this.isLoading = true

        const response = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = response.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchiseeID) {
          await this.getStudents(this.franchiseeID)
        }
        this.inProgress = false
      }
    },
    handlePageChange (value) {
      this.page = value
      this.getStudents()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getStudents()
    },
    getStudents: async function () {
      if (!this.academicYearID) {
        return this.$dialog.error({
          title: 'Error',
          text: 'Select Acadamic Year'
        })
      }
      if (!this.franchiseeID) {
        return this.$dialog.error({
          title: 'Error',
          text: 'Select franchisee'
        })
      }
      try {
        this.isLoading = true
        let url = `${constants.API_URL}/api/student/service/assign-fee-components/status?franchiseeID=${this.franchiseeID}&academicYearID=${this.academicYearID}&status=${this.selectedStatus}&&page=${this.page - 1}&&size=${this.pageSize}`
        const res = await http.get(url)
        this.students = res.data.rows
        console.log(this.students, 'this.students.rows')
        this.totalPages = res.data.totalPages

        this.totalStudents = res.data.length
      } catch (e) {
        console.log('error in student api', e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
